// Avisa al servidor para que registre la ubicación APROXIMADA (país/región) del
// usuario desde los headers de Vercel. Throttle ~1/día por dispositivo.
// Fire-and-forget: nunca bloquea ni rompe la app. Ver api/geo-ping.js.

const KEY = 'mipae_geo_ping';
const UN_DIA = 86400000;
const API_BASE = process.env.REACT_APP_API_URL || '';

export function pingGeo(accessToken) {
  if (!accessToken) return;
  try {
    const last = Number(localStorage.getItem(KEY) || 0);
    if (Date.now() - last < UN_DIA) return;
  } catch { /* sin localStorage: igual intentamos */ }
  try {
    fetch(`${API_BASE}/api/geo-ping`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}` },
      keepalive: true,
    })
      .then((res) => res.json())
      .then((data) => {
        // El throttle de 1 día solo se confirma si el perfil YA existía y
        // quedó escrito (`matched`). Un usuario recién logueado todavía sin
        // fila en `profiles` (va camino a confirmación de edad / creación de
        // perfil) recibe `matched: false`: no consumimos el throttle para
        // que un pingGeo posterior en la misma sesión (p. ej. al terminar el
        // onboarding) pueda reintentar sin esperar al día siguiente.
        if (data?.matched) {
          try { localStorage.setItem(KEY, String(Date.now())); } catch { /* noop */ }
        }
      })
      .catch(() => {});
  } catch { /* noop */ }
}
